import _ from 'lodash';
import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {getCustomFields} from '../../../../store/data/dataSelectors';
import {settingsDeleteCustomFieldsAction} from '../../../../store/panels/settings/settingsPanelActions';
import {makeGetSettingsResourcesSelectedCustomFieldIds} from '../../../../store/panels/settings/settingsPanelSelectors';
import {CustomFieldsTableMultiSelectDeleteAction} from './customFieldsTableMultiSelectDeleteAction';

/*
 * Selectors.
 */

function makeGetCustomFields() {
  return createSelector(
    [makeGetSettingsResourcesSelectedCustomFieldIds(), getCustomFields],
    (selectedCustomFieldIds, customFields) =>
      _(selectedCustomFieldIds)
        .map((customFieldId) => customFields[customFieldId])
        .compact()
        .value(),
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  customFields: makeGetCustomFields(),
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  onDeleteCustomFields: settingsDeleteCustomFieldsAction,
}));

export const CustomFieldsTableMultiSelectDeleteActionContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CustomFieldsTableMultiSelectDeleteAction);
